import { Injectable } from '@angular/core';
import { GridHeader, GridEvent } from '../interfaces/grid';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { Observable } from 'rxjs';
import { UrlBuilder } from '../../../core';

@Injectable()
export class SubjectSearchService {

    public subjectIDSearchHeader: GridHeader[] = [
        {
            displayText: 'Patient No.',
            key: 'patientNumber',
            sort: 'asc',
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Protocol',
            key: 'protocolCode',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Project No.',
            key: 'projectNumber',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Investigator Name',
            key: 'investigatorName',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Investigator No.',
            key: 'investigatorNumber',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Country',
            key: 'country',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Screening No.',
            key: 'screeningNumber',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Age/ Date of Birth',
            key: 'displayAge',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Visits',
            key: 'visits',
            hideSort: true,
            defaultValue: '',
            sort: null,
            isLink: true
        },
        {
            displayText: 'Samples',
            defaultValue: '',
            key: 'samples',
            hideSort: true,
            sort: null,
            isLink: true
        }
    ];

    public subjectVisitHeader: GridHeader[] = [
        {
            displayText: 'Protocol Visit Code',
            key: 'visitCode',
            sort: 'asc',
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Visit Description',
            key: 'visitDescription',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Collection Date',
            key: 'collectionDate',
            sort: null,
            isDate: true,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Accession',
            key: 'accessionNumber',
            sort: null,
            isLink: true,
            enableFilter: true,
            enableSearch: true
        }
    ];

    public subjectSampleHeader: GridHeader[] = [
        {
            displayText: 'Protocol',
            key: 'protocolCode',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Accession Id',
            key: 'accessionId',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Accession',
            key: 'accessionNumber',
            sort: null,
            isLink: true,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Container Number',
            key: 'containerNumber',
            sort: null,
            enableFilter: true,
            enableSearch: true
        },
        {
            displayText: 'Barcode',
            key: 'barcode',
            sort: null,
            isLink: true,
            enableFilter: true,
            enableSearch: true
        },
    ];

    constructor(
        private sampleTrackingStorage: SampleTrackingStorage,
        private urlBuilder: UrlBuilder) { }

    public visitSampleGridItemClick(selectedItem: GridEvent) {
        let data = {
            accessionNumber: selectedItem.data.accessionNumber,
            containerNumber: selectedItem.data.containerNumber,
        };
        if (selectedItem.header.key === 'accessionNumber') {
            data.containerNumber = null;
        }
        this.sampleTrackingStorage.sampleSearchData = new Observable(ob => ob.next(data));
        if (selectedItem.header.key === 'accessionNumber') {
            this.urlBuilder.esa().sampletracking().visitDetails().navigate();
            return;
        }
        this.urlBuilder.esa().sampletracking().sampleDetails(data.containerNumber).navigate();
    }
}